import emoji from '../util/emoji.js'

// 获取登录凭证
export function getLoginInfo(){
	let jsonJnfo = localStorage.getItem('imLoginInfo')
	if(jsonJnfo === undefined || jsonJnfo === null){
		return false
	}
	try{
		let info = JSON.parse(jsonJnfo)
		if(info.id == 0){
			return false
		}
		if(info.expireTime < (new Date).getTime()){
			return false
		}
		return info
	}catch(e){
		console.error(e)
		return false
	}
}

// 获取登录管理员的id
export function getLoginId(){
	let info = getLoginInfo()
	if(!info){
		return 0
	}
	return info.id
}

// 获取当前时间，格式：YYYY-MM-dd HH:mm:ss
export function getCurrentTime(){
	return formatTimeToYMDHms(new Date().getTime())
}

// 转换时间，将时间戳转换为YYYY-MM-DD HH:mm:ss格式的
export function formatTimeToYMDHms(time){
	if(time.toString().length === 10){
		time = parseInt(time) * 1000
	}
	let date = new Date(time)
	let years = date.getFullYear()
	let month = date.getMonth()+1
	let day = date.getDate()
	let hours = date.getHours()
	let minute = date.getMinutes()
	let second = date.getSeconds()
	month = month<10 ? '0' + month : month
	day = day < 10 ? '0' + day : day
	hours = hours<10 ? '0' + hours : hours
	minute = minute < 10 ? '0' + minute : minute,
	second = second < 10 ? '0' + second : second
	return years + '-' + month + '-' + day + ' ' + hours + ':' + minute + ':' + second
}


// 返回当前时间戳，如果有参数，则返回指定时间对应的时间戳
export function getCurrentTimestamp(time){
	let date = new Date()
	if(time !== undefined){
		date = new Date(time)
	}
	return date.getTime()	
}

// socket消息格式转换为数据库保存格式
export function socketType2DbType(type){
	let dbType = ''
	switch(type){
		case "_Text":
			dbType = 'text'
			break
		case "_Image":
			dbType = 'image'
			break
		case "_Voice":
			dbType = 'voice'
			break
		case "_Video":
			dbType = 'video'
			break
		case "_Applet":
			dbType = 'program'
			break
		case "redPackage":
			dbType = 'red_package'
			break
		case "transferAccounts":
			dbType = 'transfer_accounts'
			break
		case "_System":
			dbType = 'system'
			break
		case "_CustomImage":
			dbType = 'image'
			break
		case "_File":
			dbType = 'file'
			break
		case "_Link":
			dbType = 'link'
			break
		case "_Finder":
			dbType = 'finder'
			break
		case "_FinderLive":
			dbType = 'finder_live'
			break
		case "_Position":
			dbType = 'position'
			break
		default:
			dbType = type
	}
	return dbType
}

// socket消息格式转换为数据库保存格式
export function dbType2SocketType(type){
	let dbType = ''
	switch(type){
		case "text":
			dbType = '_Text'
			break
		case "image":
			dbType = 'imageBrow'
			break
		case "voice":
			dbType = '_Voice'
			break
		case "video":
			dbType = '_Video'
			break
		case "program":
			dbType = '_Applet'
			break
		case "program2":
			dbType = 'applet'
			break
		case "red_package":
			dbType = 'redPackage'
			break
		case "transfer_accounts":
			dbType = 'transferAccounts'
			break
		case "system":
			dbType = '_System'
			break
		case "file":
			dbType = '_File'
			break
		case "link":
			dbType = '_Link'
			break
		case "finder":
			dbType = '_Finder'
			break
		case "finder_live":
			dbType = '_FinderLive'
			break
		case "position":
			dbType = '_Position'
			break
		default:
			dbType = type
	}
	return dbType
}

/**
 * 转换输入框中的文字
 * @param {Object} str
 */
export function filterInput(str) {
	// 提取索引的html标签
	let tagReg=/(<[\w\W]*?>)/ig;
	let allTags = str.match(tagReg);
	let filters = []
	if(allTags !== null){
		for (let i = 0; i < allTags.length; i++) {
			let tag = allTags[i].substr(1,allTags[i].length-2)
			if(filters.indexOf(tag) === -1){
				filters.push(tag)
			}
		}
	}
	
	// 过滤/div 和提取图片，视频，语音，emoji的url
	let msg = []
	let texts = str.match(/[^<^>]+/ig)
	let emojiReg = /\/img\/emoji\/[0-9]{0,3}\.png/ig
	let imgReg = /(http|https):\/\/.+?(.jpg|.png|.gif|.jpeg)/ig
	let base64ImgReg = /data:image\/.*?\"/ig
	let videoReg = /(http|https):\/\/.+?(.mp4)/ig
	let voiceReg = /(http|https):\/\/.+?(.mp3)/ig
	if(texts !== null){
		for (let i = 0; i < texts.length; i++) {
			let file
			if((file = texts[i].match(emojiReg)) !== null){
				let emojiName = file[0].split('.')[0].split('/')
				msg.push({
					type:'emoji',
					content: emoji.get(emojiName[emojiName.length-1])
				})
			}else if(texts[i].indexOf('img') !== -1 && (file = texts[i].match(imgReg)) !== null){
				msg.push({
					type:'image',
					content:file[0]
				})
			}else if(texts[i].indexOf('img') !== -1 && (file = texts[i].match(base64ImgReg)) !== null){
				msg.push({
					type:'base64Image',
					content:trim(file[0],'"')
				})
			}else if(texts[i].indexOf('video') !== -1 && (file = texts[i].match(videoReg)) !== null){
				msg.push({
					type:'video',
					content:file[0]
				})
			}else if((file = texts[i].match(voiceReg)) !== null){
				msg.push({
					type:'voice',
					content:file[0]
				})
			}else{
				if(texts[i] === 'div'|| texts[i] === 'p'){
					msg.push({
						type:'br',
						content:'<br/>'
					})
				}else if(filters.indexOf(texts[i]) !== -1){
					continue
				}else {
					let tempContent = trim(nbsp_to_space(texts[i])," ")
					if(tempContent === ""){
						continue
					}
					msg.push({
						type:'text',
						content: tempContent
					})
				}
			}
		}
	}

	// 将换行的字符拼接在一个消息里面
	let msgList = []
	let msgTemp = ''
	for (let i = 0; i < msg.length; i++) {
		if(msg[i].type === 'text'  || msg[i].type === 'br' || msg[i].type === 'emoji'){
			msgTemp += msg[i].content
		}else{
			if(msgTemp !== ''){
				msgList.push({
					type:'text',
					content: msgTemp
				})
				msgTemp = ''
			}
			msgList.push(msg[i])
		}
	}
	// 处理最后是文本的数据
	if(msgTemp !== ''){
		msgList.push({
			type:'text',
			content: msgTemp
		})
		msgTemp = ''
	}

	// 最终返回的数据
	let msgListBack = []
	// 去除字符串的两边的<br>
	for (let i = 0; i < msgList.length; i++) {
		if(msgList[i].type === 'text'){
			let contentTemp = trim(msgList[i].content,'<br/>')
			if(contentTemp === ''){
				continue
			}
			msgList[i].content = contentTemp
		}
		msgListBack.push(msgList[i])
	}
	return msgListBack
}


/**
 * 过滤字符串左右的指定字符
 * @param str
 * @param char
 * @returns {*}
 */
export function trim(str,char) {
	return rtrim(ltrim(str,char),char)
}

/**
 * 过滤字符串最左侧的指定字符
 * @param str
 * @param char
 * @returns {string|*}
 */
export function ltrim(str,char){
	let regExp = new RegExp('^('+char+')+')
    return str.replace(regExp,'')
}

/**
 * 过滤字符串最右侧的指定字符
 * @param str
 * @param char
 * @returns {string|*}
 */
export function rtrim(str,char){
	let regExp = new RegExp('('+char+')+$')
	return str.replace(regExp,'')
}


// &nbsp;转换成空字符串
export function nbsp_to_space(strValue){
    return strValue.replace(/&nbsp;/g, ' ')
}

// 获取本地缓存配置列表
export function getLocalConfigList(){
    let list = localStorage.getItem("yswl_config")
	if(list === null){
		list = {
			newMsgMusic: true
		}
	}else{
		list = JSON.parse(list)
	}
	return list
}

// 获取本地缓存配置
export function getLocalConfig(key){
    let configs = localStorage.getItem("yswl_config")
	if(configs === null){
		return null
	}
	configs = JSON.parse(configs)
	let val =  configs[key]
	if(val === undefined){
		val = ''
	}
	return val
}

// 初始化本地缓存配置
export function initLocalConfig(){
	let config = {
		newMsgMusic: true
	}
    localStorage.setItem("yswl_config",JSON.stringify(config))
}

// 保存本地缓存配置
export function saveLocalConfig(config){
    localStorage.setItem("yswl_config",JSON.stringify(config))
}

 // 格式化文件大小
export function formatFileSize(size){
	let fromatStr
	if(size < 1024){
	 fromatStr = size + 'B'
	}else if(size < 1024 * 1024){
	 fromatStr = Math.ceil(100*size/1024) / 100 + 'KB'
	}else{
	 fromatStr = Math.ceil(100*size/1024/1024) / 100 + 'MB'
	}
	return fromatStr
}

// 根据消息中的变量，自动替换文本消息
export function varToReplace(content,chatUser){
	// 替换粉丝昵称 {$fansName}
	if(content.indexOf("{$fansName}") !== -1){
		let fans_wx_name = chatUser.fans_wx_name !== undefined ? chatUser.fans_wx_name : ''
		content = content.replace(/\{\$fansName\}/g, fans_wx_name)
	}
	// 替换粉丝昵称 {$customName}
	if(content.indexOf("{$customName}") !== -1){
		let custom_wx_name = chatUser.custom_wx_name !== undefined ? chatUser.custom_wx_name : ''
		content = content.replace(/\{\$customName\}/g, custom_wx_name)
	}
	return content
}